export const STATE_ZERO_OID = 'state-zero';
export const pxQuestionsAnswerTypes = {
    PERSONAL_BROKERAGE_ACCOUNT: 'PERSONAL_BROKERAGE_ACCOUNT',
    ROBO_PERSONAL_BROKERAGE_ACCOUNT: 'ROBO_PERSONAL_BROKERAGE_ACCOUNT',
    COMPLETE: 'COMPLETE',
}